module.exports = __webpack_public_path__ + "img/92.7934aa26.webp";